import { App } from "antd";
import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import {
  setBailiffJobPreview,
  setBailiffJobSelected,
} from "store/bailiff/bailiff/job/bailiff_job.action";
import {
  // getBailiffQR,
  getJobBailiffAndGenerateQR,
  setOrderBailiffOpenPayment,
  setOrderBailiffQR,
} from "store/bailiff/payment/order/order_bailiff.action";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const useJobDeposit = () => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  // -------------------------- STATE ---------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------

  const handleOpenPreview = (data) => {
    dispatch(setBailiffJobPreview(data));
  };

  const handleClosePreview = () => {
    dispatch(setBailiffJobPreview(null));
  };

  // handle deposit v2. (no dialog.)
  const handleDeposit = useCallback(
    (data) => {
      console.log({ data });
      const jobId = data?.id;
      const type = "deposit";
      // const type =
      //   data?.status === "waiting for deposit" ? "deposit" : "payOff";
      setLoading(true);
      dispatch(setBailiffJobSelected(data));
      dispatch(setOrderBailiffOpenPayment(true));
      dispatch(
        getJobBailiffAndGenerateQR({ jobId, type }, (res) => {
          setLoading(false);
          if (res?.status === 500) {
            message.error(res?.data);
          }
        }),
      );
    },
    [dispatch],
  );

  const handleClose = () => {
    dispatch(setOrderBailiffOpenPayment(false));
    dispatch(setOrderBailiffQR(null));
    dispatch(setBailiffJobSelected(null));
    dispatch(setBailiffJobPreview(null));
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return {
    loading,
    handleDeposit,
    handleClose,
    handleOpenPreview,
    handleClosePreview,
  };
};
